import React, { useState, type Dispatch, type SetStateAction } from "react";
import { Instagram, Youtube } from "lucide-react";
import { FilterDropdown } from "./FilterDropdown";

const PLATFORMS = [
  { label: "Instagram", value: "instagram", Icon: Instagram },
  { label: "YouTube", value: "youtube", Icon: Youtube },
];

interface Props {
  selectedPlatforms: string[];
  setSelectedPlatforms: Dispatch<SetStateAction<string[]>>;
}

export function PlatformFilter({ selectedPlatforms, setSelectedPlatforms }: Props) {
  const [open, setOpen] = useState(false);

  const toggle = (value: string) => {
    setSelectedPlatforms((prev) =>
      prev.includes(value) ? prev.filter((p) => p !== value) : [...prev, value]
    );
  };

  return (
    <FilterDropdown
      label="Platform"
      count={selectedPlatforms.length}
      open={open}
      setOpen={setOpen}
      width="w-[180px]"
    >
      {PLATFORMS.map(({ label, value, Icon }) => {
        const isSelected = selectedPlatforms.includes(value);
        return (
          <button
            key={value}
            type="button"
            onClick={() => toggle(value)}
            className="w-full text-left px-4 py-3 rounded-[14px] font-raleway text-[16px] hover:bg-[#F3F4F6]"
          >
            <div className="flex items-start gap-3">
              <div className="mt-1 w-4 h-4 rounded-full border-2 border-[#9CA3AF] flex items-center justify-center">
                {isSelected && <div className="w-2 h-2 rounded-full bg-[#9333EA]" />}
              </div>
              <div className="flex items-center gap-2">
                {value === "instagram" ? (
                  <img src="/icons/instagram-logos/GradientGlyph/Instagram_Glyph_Gradient.png" alt="Instagram" className="w-4 h-4 object-contain" />
                ) : (
                  <Icon className="w-4 h-4" />
                )}
                <span className="text-[16px] leading-none">{label}</span>
              </div>
            </div>
          </button>
        );
      })}

      <button
        type="button"
        onClick={() => setSelectedPlatforms([])}
        className="w-full text-left px-4 py-3 rounded-[14px] font-raleway text-[16px] hover:bg-[#F3F4F6]"
      >
        <div className="flex items-center gap-3">
          <div className="w-4 h-4 rounded-full border-2 border-[#9CA3AF] flex items-center justify-center">
            {selectedPlatforms.length === 0 && <div className="w-2 h-2 rounded-full bg-[#9333EA]" />}
          </div>
          <span className="text-[16px]">All</span>
        </div>
      </button>
    </FilterDropdown>
  );
}
